export default {
  pushInfoDetail: {
    title: "推送档案",
    component: () =>
      import(
        /* webpackChunkName: "archive_detail" */ "@/mods/archive/pushManage/detailView/PushInfoDetail"
      ),
  },
};
